<div class="row">
    <div [ngClass]="(refNum | json) != '{}' ? 'col-sm-6' : 'col-sm-11'">
        <kendo-grid #uiGrid
                    [data]="gridData"
                    [sort]="gridState.sort"
                    [sortable]="false"
                    [pageable]="false"
                    [filterable]="false"
                    [resizable]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column title="Action" width="105" [hidden]="readonly">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div *ngIf="readonly!=true">
                        <button (click)="edit(dataItem)" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1"><i class="fas fa-pencil-alt"></i></button>
                        <button (click)="delete(dataItem)" class="btn btn-sml btn-danger" title="Delete" tabindex="-1"><i class="fas fa-times"></i></button>
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="referenceType" title="Type"></kendo-grid-column>
            <kendo-grid-column field="value" title="Ref #"></kendo-grid-column>
        </kendo-grid>
    </div>
    <div class="col-sm-1" *ngIf="readonly!=true">
        <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()"><i class="fas fa-plus"></i></button>
    </div>
    <div class="col-sm-6" *ngIf="(refNum | json) != '{}'">
        <reference-number-form [refNum]="refNum" [recordType]="recordType" (onRefresh)="getReferenceNumbers()"></reference-number-form>
    </div>
</div>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay':isLoading}" *ngIf="isLoading">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>
